import { PureComponent } from 'react'
import cx from 'classnames'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  PRODUCT_WARRANTY_HANDLER,
  PRODUCT_WARRANTY_HANDLER_MAP,
  FIELD_MAX_LENGTH
} from '@vzmi/shp_shared_compo/constants/proposal'
import { MenuSelect } from '@vzmi/shp_shared_compo'
import styles from './Warranty.css'
import {
  FormRow,
  When,
  InputCountField,
  RadioGroupInputField,
  TextareaCountField,
  InputField,
  FormError
} from '../../../Common/Form'
import { Field, FormValueSelector } from '../../../Common/forms'
import {
  WARRANTY_PERIOD_TYPES,
  WARRANTY_SCOPE_TYPES,
  WARRANTY_PERIOD_KEYS,
  WARRANTY_PERIOD_NONE,
  WARRANTY_SCOPE_OTHER,
  WARRANTY_STATUS_TYPES
} from '../../../../constants/proposalTypes'
import SingleLineText from '../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import MultiLineText from '../../Common/ReadOnlyComponents/MultiLineText/MultiLineText'
import {
  isCustomWarranty,
  isNoneWarrantyPeriod
} from '../../Common/ProposalForm/Shared/util'
import { ListingFieldConfig } from '../../Common/ProposalForm/Shared/FieldConfig'
import {
  customWarrantyScopeValidation
} from '../../Common/ProposalForm/Shared/validation/fieldLevelValidator'
import { filterHtmlTag, normalizeAll } from '../../Common/ProposalForm/Shared/normalizers'
import {
  WARRANTY_DESC_FIELD,
  getWarrantyFields,
  WARRANTY_SCOPE_FIELD
} from '../../Shared'
import { removeNonPrintableCharParser } from '../../../../lib/parser'
import { required } from 'redux-form-validators'

const warrantyPeriodCustomInputNormalizer = normalizeAll(removeNonPrintableCharParser, filterHtmlTag)

class Warranty extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      /**
       * 存畫面上 [保固範圍] radio button 的 value，
       */
      warrantyScopeRadioValue: '',
      showCustomScopeInput: false
    }
    this.fields = getWarrantyFields(props.fieldName)
  }

  componentDidUpdate (prevProps) {
    const { warrantyScope } = prevProps
    const { warrantyScope: nextWarrntyScope } = this.props
    if (nextWarrntyScope && warrantyScope !== nextWarrntyScope) {
      this.handleWarrantyScopeChange(nextWarrntyScope)
    }
  }

  handleSelectPeriod = ({ value: selectedPeriod = WARRANTY_PERIOD_NONE }) => {
    const { triggerFieldChange } = this.props
    if (isNoneWarrantyPeriod(selectedPeriod)) {
      triggerFieldChange(this.fields.warrantyScopeField, null)
      triggerFieldChange(this.fields.warrantyHandlerField, null)
    } else {
      const { warrantyHandler } = this.props
      if (!warrantyHandler || !_.get(PRODUCT_WARRANTY_HANDLER_MAP, warrantyHandler)) {
        triggerFieldChange(
          this.fields.warrantyHandlerField,
          PRODUCT_WARRANTY_HANDLER.OFFICIAL
        )
      }
    }
    triggerFieldChange(this.fields.warrantyPeriodField, selectedPeriod)
  }

  handleSubmitCustomPeriod = (inputValue, foundInputOption) => {
    const foundValue = _.get(foundInputOption, 'value', null)
    this.handleSelectPeriod({
      value: foundValue || inputValue
    })
  }

  handleWarrantyScopeChange = value => {
    const { triggerFieldChange } = this.props
    const showCustomScopeInput = isCustomWarranty(value)
    this.setState(
      () => ({
        showCustomScopeInput
      }),
      () => {
        if (!showCustomScopeInput) {
          triggerFieldChange(this.fields.warrantyCustomScopeField, '')
        }
      }
    )
  }

  handleWarrantyScopeRadioChange = value => {
    this.handleWarrantyScopeChange(value)
  }

  render () {
    const {
      showCustomScopeInput
    } = this.state
    const {
      readOnly,
      isNewProposal,
      warrantyPeriod = '',
      warrantyScope,
      mustShowFormError,
      withoutMargin
    } = this.props
    const isCustomWarranty = (warrantyScope === WARRANTY_SCOPE_OTHER)

    return (
      <div
        className={styles.Warranty}
        data-role='warranty'
      >
        <FormRow
          key='period'
          label='保固期限'
          withoutMargin={withoutMargin}
        >
          {
            readOnly
              ? (
                <SingleLineText content={warrantyPeriod} />
              )
              : (
                <>
                  <MenuSelect
                    enableCustomInput
                    editableCustomInput
                    key='attrSelect'
                    data-role='product-warranty-period'
                    enableFilter={false}
                    inputPickerValue={warrantyPeriod}
                    customInputPlaceholder='請輸入期限'
                    customInputButtonText='自訂保固期限'
                    normalizeCustomInput={warrantyPeriodCustomInputNormalizer}
                    onCustomInputSubmit={this.handleSubmitCustomPeriod}
                    onSelect={this.handleSelectPeriod}
                    className={styles.productWarrantyPeriodSelect}
                    popupClassName={styles.productWarrantyPeriodSelectMenu}
                    options={WARRANTY_PERIOD_TYPES}
                    customInput={
                      !_.includes(WARRANTY_PERIOD_KEYS, warrantyPeriod)
                        ? warrantyPeriod
                        : ''
                    }
                    showErrorOnActive={isNewProposal}
                    mustShowFormError={mustShowFormError}
                  />
                  <When
                    value={_.size(warrantyPeriod) > FIELD_MAX_LENGTH.WARRANTY_SCOPE}
                    isTrue
                  >
                    <FormError
                      showFormError
                      error={`最多輸入 ${FIELD_MAX_LENGTH.WARRANTY_SCOPE} 個字`}
                    />
                  </When>
                  <When
                    value={_.isEmpty(warrantyPeriod)}
                    isTrue
                  >
                    <FormError
                      showFormError
                      error='無法判斷賣場之保固內容，請重新填寫'
                    />
                  </When>
                </>
              )
          }
        </FormRow>
        <When
          value={!isNoneWarrantyPeriod(warrantyPeriod)}
          isTrue
        >
          <FormRow
            key='source'
            label='保固來源'
            labelAlign='top'
            withoutMargin={withoutMargin}
          >
            <Field
              name={this.fields.warrantyHandlerField}
              component={RadioGroupInputField}
              data-role='product-warranty-source-radio'
              className={styles.warrantSourceRadio}
              options={[
                { label: '原廠保固', value: PRODUCT_WARRANTY_HANDLER.OFFICIAL },
                { label: '經銷保固', value: PRODUCT_WARRANTY_HANDLER.RETAILER }
              ]}
              disabled={readOnly}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
          <FormRow
            key='scope'
            label='保固範圍'
            labelAlign='top'
            withoutMargin={withoutMargin}
          >

            <Field
              name={this.fields.warrantyScopeField}
              data-role='product-warranty-scope-radio'
              className={styles.productWarrantyScopeRadio}
              component={RadioGroupInputField}
              onChange={this.handleWarrantyScopeRadioChange}
              options={WARRANTY_SCOPE_TYPES}
              disabled={readOnly}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
            {/* 選擇成需要自訂內容或是目前保固範圍為其他就需要顯示自訂欄位 */}
            <When
              value={showCustomScopeInput || isCustomWarranty}
              isTrue
            >
              <Field
                {...ListingFieldConfig.getField(WARRANTY_SCOPE_FIELD)}
                name={this.fields.warrantyCustomScopeField}
                component={readOnly ? InputField : InputCountField}
                disabled={readOnly}
                className={styles.productWarrantyScope}
                validate={customWarrantyScopeValidation}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
            </When>
          </FormRow>
        </When>
        <FormRow
          key='status'
          label='產品狀態'
          labelAlign='top'
          withoutMargin={withoutMargin}
        >
          <Field
            name={this.fields.warrantyStatusField}
            data-role='product-status-radio'
            className={styles.productWarrantyStatusRadio}
            component={RadioGroupInputField}
            options={WARRANTY_STATUS_TYPES}
            disabled={readOnly}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
            validate={required({ msg: '請選擇產品狀態' })}
          />
        </FormRow>
        <FormRow
          key='description'
          label='保固說明'
          subTitle='(非必填)'
          withoutMargin={withoutMargin}
          withInputCountPaddingBottom
        >
          <Field
            {...ListingFieldConfig.getField(WARRANTY_DESC_FIELD)}
            name={this.fields.warrantyDescField}
            component={
              readOnly
                ? MultiLineText
                : TextareaCountField
            }
            className={cx(styles.productWarrantyDesc, { [styles.readOnly]: readOnly })}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
      </div>
    )
  }
}

Warranty.propTypes = {
  readOnly: PropTypes.bool,
  triggerFieldChange: PropTypes.func,
  warrantyHandler: PropTypes.string,
  warrantyPeriod: PropTypes.string,
  warrantyScope: PropTypes.string,
  fieldName: PropTypes.string
}

const FormValueWarranty = props => {
  const {
    warrantyPeriodField,
    warrantyScopeField,
    warrantyHandlerField
  } = getWarrantyFields(props.fieldName)
  return (
    <FormValueSelector
      selector={select => ({
        warrantyPeriod: select(warrantyPeriodField),
        warrantyScope: select(warrantyScopeField),
        warrantyHandler: select(warrantyHandlerField),
        mustShowFormError: select('mustShowFormError')
      })}
    >
      {values => (
        <Warranty
          {...props}
          {...values}
        />
      )}
    </FormValueSelector>
  )
}

export default FormValueWarranty
